import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './theme/shared/shared.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';

import { ToggleFullScreenDirective } from './theme/shared/full-screen/toggle-full-screen';

/* Menu Items */
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NgbButtonsModule, NgbDropdownModule, NgbTabsetModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import {NetworkHelper} from "./core/helpers/network.helper";
import {HttpClient, HttpHandler} from "@angular/common/http";
import {NotAuthGuard} from "./core/helpers/notauth.guard";
import {SuperadminGuard} from "./core/helpers/superadmin.guard";
import {AuthService} from "./core/services/auth.service";
import {EventManager} from "./core/helpers/event-manager";
import {PageBuilderComponent} from "./theme/layout/preview/page-builder.component";
import {FileUploadService} from "./core/services/file-upload.service";
import {PopupHelperService} from "./core/helpers/popup-helper.service";
import {FormsModule} from "@angular/forms";
import {LandingComponentsModule} from "./theme/landing-components/landing-components.module";
import {RouterModule} from "@angular/router";

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    PageBuilderComponent,
    AuthComponent,
    NavigationComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    NavLeftComponent,
    NavSearchComponent,
    NavRightComponent,
    ConfigurationComponent,
    ToggleFullScreenDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    NgbDropdownModule,
    NgbTooltipModule,
    RouterModule,
    LandingComponentsModule,
    NgbButtonsModule
  ],
  providers: [NavigationItem, SuperadminGuard, NotAuthGuard, AuthService, EventManager,FileUploadService,PopupHelperService],
  bootstrap: [AppComponent]
})
export class AppModule { }
